import { useState } from "react";
import SellerStep from "../../components/seller/SellerStep";
import { SharedFormField } from "../../components/shared";
import ChoiceGroup from "../../components/forms/ChoiceGroup";
import CheckboxGroup from "../../components/forms/CheckboxGroup";
import { useSellerState } from "../../js/state/sellerState";

export default function SellerConditionNotes() {
  const saved = useSellerState().seller.portfolio.conditionNotes || {};
  const [form, setForm] = useState({
    overall: saved.overall || "",
    roofAge: saved.roofAge || "",
    hvacAge: saved.hvacAge || "",
    waterHeaterAge: saved.waterHeaterAge || "",
    knownIssues: saved.knownIssues || [],
    disclosures: saved.disclosures || "",
    notes: saved.notes || "",
  });

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  return (
    <SellerStep
      title="Condition notes"
      lead="Honest condition is a listing asset. Your agent would rather hear it now than after the inspection."
      sectionKey="conditionNotes"
      value={form}
    >
      <section className="checklist-section">
        <h2>Overall & Systems</h2>
        <ChoiceGroup
          label="Overall condition"
          name="overall"
          value={form.overall}
          onChange={update}
          options={[
            { value: "excellent", label: "Excellent" },
            { value: "good", label: "Good" },
            { value: "fair", label: "Fair / mixed" },
            { value: "needs-work", label: "Needs work" },
          ]}
        />
        <div className="two-col">
          <SharedFormField label="Roof age (years, approx.)" name="roofAge" value={form.roofAge} onChange={update} />
          <SharedFormField label="HVAC age (years, approx.)" name="hvacAge" value={form.hvacAge} onChange={update} />
        </div>
        <SharedFormField
          label="Water heater age (years, approx.)"
          name="waterHeaterAge"
          value={form.waterHeaterAge}
          onChange={update}
        />
      </section>

      <section className="checklist-section">
        <h2>Known Items</h2>
        <CheckboxGroup
          label="Anything a buyer or inspector is likely to flag"
          name="knownIssues"
          values={form.knownIssues}
          onChange={update}
          layout="grid"
          options={[
            { value: "roof", label: "Roof wear" },
            { value: "foundation", label: "Foundation / settlement" },
            { value: "moisture", label: "Moisture / drainage" },
            { value: "electrical", label: "Electrical" },
            { value: "plumbing", label: "Plumbing" },
            { value: "windows", label: "Windows / seals" },
            { value: "pest", label: "Pest history" },
            { value: "none", label: "None that I know of" },
          ]}
        />
        <SharedFormField
          label="Disclosure notes"
          name="disclosures"
          type="textarea"
          value={form.disclosures}
          onChange={update}
          placeholder="Prior claims, unpermitted work, easements, or items already on a seller disclosure."
        />
        <SharedFormField
          label="Condition notes for my agent"
          name="notes"
          type="textarea"
          value={form.notes}
          onChange={update}
          placeholder="What you plan to repair vs. credit vs. sell as-is."
        />
      </section>
    </SellerStep>
  );
}
